module.exports = __webpack_public_path__ + "a3b9bebd6b95f84713787e243cd2afc9.png";